export function getCurrentTimeFormatted() {
  const now = new Date();

  const pad = (number: number) => (number < 10 ? "0" + number : number);

  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  return `${hours}_${minutes}_${seconds}`;
}

export function calculateOneMonthAgoToday() {
  const currentDate = new Date();
  return calculateOneMonthAgo(currentDate);
}

function calculateOneMonthAgo(givenDate: Date) {
  const previousMonthFirstDay = new Date(givenDate);
  previousMonthFirstDay.setMonth(givenDate.getMonth() - 1, 1);

  const previousMonthLastDay = new Date(givenDate);
  previousMonthLastDay.setDate(0);

  const startDateString = formatDate(previousMonthFirstDay);
  const endDateString = formatDate(previousMonthLastDay);

  return {
    startDate: startDateString,
    endDate: endDateString,
  };
}

function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
